import { Box, Grid } from '@mui/material'
import React, { useEffect, useMemo, useState } from 'react'
import LeftSection from './LeftSection'
import RightSection from './RightSection'
import '../../style/Booking.scss'
import { useDispatch, useSelector } from 'react-redux'
import { getCities, getSearchRoutesBookBusTickets } from '../../redux/Booking/BookingActions'
import { showErrorAlert } from '../../redux/Actions'
import { checkAndFocus, focusElemnt, formatDate1, shortcutKey } from '../../utils/helpers'
import { bkgDetailsObj, filterOptObj, tripDetailsFormat } from './constant'
import Header from '../../common/Header'
import { useRecentSearch } from '../../hook/useRecentSearch'
import dayjs from 'dayjs'
import { useLoadTripDetails } from '../../hook/useLoadTripDetails'
import LogoHeader from '../../common/LogoHeader'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { use } from 'react'
const Booking = () => {
    const dispatch = useDispatch();
    const store = useSelector((store) => store);
    const { getRecentSearches } = useRecentSearch();
    const { loadTripDetails } = useLoadTripDetails();
    const { user } = store;
    const { userDetails } = user;
    const [filterOptions, setFilterOptions] = useState({
        mainCity: [],
        fromCity: [],
        toCity: [],
    });
    const [filterValues, setFilterValues] = useState({
        fromCity: [],
        toCity: [],
        journeyDate: formatDate1(window.getTime ? window.getTime() : new Date()),
    });
    const [tableData, setTableData] = useState([]);
    const [bkgDeatails, setBkgDetails] = useState(bkgDetailsObj);
    const [filterOpt, setFilterOpt] = useState(filterOptObj);
    const [selectedSeat, setSelectedSeat] = useState([])
    const [showLogoHeader, setShowLogoHeader] = useState(localStorage.getItem('logoHeaderHide') || true)
    useEffect(() => {
        if (Object.keys(userDetails).length > 0) {
            fetchData()
        }
    }, [userDetails])

    useEffect(() => {
        const handleKeyDown = (e) => {
            shortcutKey(e)
        };

        window.addEventListener("keydown", handleKeyDown);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, []);


    const fetchData = () => {
        const body = {
            intAgentID: userDetails?.AgentID || 0,
            strKeyCode: ''
        }
        dispatch(getCities(body, true, 24 * 60 * 60 * 1000)).then((res) => {
            if (res?.data?.status) {
                let cities = res?.data?.Data?.Table || []
                let userCity = cities.filter((obj) => obj.FromCityID === userDetails?.CityID);
                let defFromCity = userCity?.length ? [userCity[0]] : [cities[0]];
                let toCityList = cities.filter((obj) => obj.FromCityID === defFromCity[0].FromCityID);
                const recentSearchData = getRecentSearches()
                if (recentSearchData.length !== 0) {
                    handleDefTrip(recentSearchData[0], cities)
                    return
                }
                setFilterOptions((prev) => ({
                    ...prev,
                    fromCity: cities,
                    mainCity: cities,
                    toCity: toCityList,
                }))

                setFilterValues((prev) => ({
                    ...prev,
                    fromCity: defFromCity.length ? [defFromCity[0]] : [],
                    toCity: toCityList.length ? [toCityList[0]] : [],
                }))
                handleSearch(dayjs(), defFromCity.length ? [defFromCity[0]] : [], toCityList.length ? [toCityList[0]] : [])

            } else {
                dispatch(showErrorAlert(res?.data?.message))
            }
        })
    }

    const handleDefTrip = (data, mainCity = []) => {
        const toCityList = mainCity.filter(
            (obj) =>
                obj.FromCityID === data.source.FromCityID
        );
        let toCity = []
        if (toCityList.length !== 0) {
            toCity = toCityList.filter((obj) => obj.ToCityID === data.destination.ToCityID)
        }
        let defToCity = toCity.length ? [toCity[0]] : [toCityList[1]]
        let defFromCity = toCityList.length ? [toCityList[0]] : []
        setFilterValues((prev) => ({ ...prev, fromCity: defFromCity, toCity: defToCity, mainCity: mainCity }))
        setFilterOptions((prev) => ({ ...prev, toCity: toCityList, fromCity: mainCity, mainCity: mainCity }))
        handleSearch(data.journeyDate, defFromCity, defToCity)
    }

    const handleSearch = (journeyDate = dayjs(), fromCity = [], toCity = []) => {
        if (fromCity.length === 0 || toCity.length === 0) {
            focusElemnt('toCity')
            return
        }
        const body = {
            intUserID: userDetails?.AgentUserID || 0,
            intFromCityID: fromCity[0]?.FromCityID,
            intToCityID: toCity[0]?.ToCityID,
            dtJDate: dayjs(journeyDate).format('YYYY-MM-DD'),
            intAgentID: userDetails?.AgentID || 0,
            strEntityType: 'A'
        }
        dispatch(getSearchRoutesBookBusTickets(body, true, 5 * 60 * 1000)).then((res) => {
            if (res?.data?.status) {
                let data = res?.data?.Data?.Table || {};
                let tripData = tripDetailsFormat(data)
                if (tripData.length !== 0) {
                    handleTrip(tripData[0])
                }
                setTableData(tripData);
                requestAnimationFrame(() => checkAndFocus(`trip-${0}`));

            }
        })
    }
    const handleTrip = (trip) => {
        handleResetTripData()
        loadTripDetails({ tripDetails: trip, setBkgDetails, setFilterOpt, setSelectedSeat });
    }

    const handleReset = () => {
        setTableData([])
        handleResetTripData()
    }

    const handleResetTripData = () => {
        setSelectedSeat([])
        setBkgDetails(bkgDetailsObj)
        setFilterOpt(filterOptObj)

    }

    return (
        <Box sx={{ backgroundColor: '#f1f1f1', minHeight: '100vh' }}>
            {showLogoHeader &&
                <LogoHeader setShowLogoHeader={setShowLogoHeader} />
            }
            <Header handleRefresh={fetchData} bkgDeatails={bkgDeatails} showLogoHeader={!showLogoHeader} setShowLogoHeader={setShowLogoHeader} />
            <Box className='booking_page' >
                <Grid container
                    direction="row"
                    justifyContent="flex-start"
                    flexWrap="wrap"
                    alignItems="stretch"
                    sx={{ height: '100%', padding: '0px' }}
                    columnSpacing={{ xs: '12px' }}
                    rowSpacing={{ xs: '12px' }}
                >
                    <Grid item size={4} sx={{ height: '100%' }}>
                        <LeftSection bkgDeatails={bkgDeatails} filterOpt={filterOpt}
                            selectedSeat={selectedSeat}
                            setSelectedSeat={setSelectedSeat}
                            handleResetTripData={handleResetTripData}
                            setBkgDetails={setBkgDetails}
                            showLogoHeader={showLogoHeader}
                            setFilterOpt={setFilterOpt}
                        />
                    </Grid>
                    <Grid item size={8} sx={{ height: '100%' }}>
                        <RightSection
                            filterOptions={filterOptions}
                            filterValues={filterValues}
                            setFilterOptions={setFilterOptions}
                            setFilterValues={setFilterValues}
                            setTableData={setTableData}
                            tableData={tableData}
                            bkgDeatails={bkgDeatails}
                            setBkgDetails={setBkgDetails}
                            filterOpt={filterOpt}
                            setFilterOpt={setFilterOpt}
                            handleReset={handleReset}
                            selectedSeat={selectedSeat}
                            handleResetTripData={handleResetTripData}
                            setSelectedSeat={setSelectedSeat}
                        />
                    </Grid>
                </Grid>
            </Box>
        </Box>
    )
}

export default Booking